import React from 'react'

export function Icon({ status = 'neutral', size = 2, hidden }) {
  const baseStyling = 'm-0 p-0'
  const sizeStyling = `fa-${size}x`
  const specificStyling = {
    ok: 'fas fa-check-circle text-success',
    error: 'fas fa-times-circle text-danger',
    neutral: 'fas fa-minus-circle text-secondary',
  }
  console.log(hidden)
  return (
    <i
      className={`${specificStyling[status]} ${sizeStyling} ${baseStyling}`}
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
    />
  )
}
